import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-check",
  "use": "foquz-icon-check-usage",
  "viewBox": "0 0 22 16",
  "content": "<symbol viewBox=\"0 0 22 16\" fill=\"none\" id=\"foquz-icon-check\"><path d=\"M2 7.177l7.045 6.948L20 2\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol